// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"719":"18b020d2191d9dc5","1242":"42517efcdd18dd1a","3588":"c24f723829e24386","3719":"e684775fca2a2342","5315":"a6661893c93850da","6021":"dfe158c148daf4af","6681":"3058a143948a8139","8990":"6061beb4d56790b4"}[chunkId] + ".css";
};